import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { VideoOutgoingTemplate } from "~/features/call/video/VideoOutgoingTemplate";
import { useCallStore } from "~/stores/useCallStore";

const outgoingSearchSchema = z.object({
  partner_id: z.string().optional(),
  partner_name: z.string().catch(""),
  partner_avatar: z.string().optional(),
  partner_age: z.coerce.number().optional(),
});

const VideoOutgoingPage = () => {
  const search = Route.useSearch();
  // partner_id は beforeLoad で必須チェック済み
  return (
    <VideoOutgoingTemplate
      partnerId={search.partner_id ?? ""}
      partnerName={search.partner_name}
      partnerAvatarUrl={search.partner_avatar}
      partnerAge={search.partner_age}
    />
  );
};

export const Route = createFileRoute("/_authenticated/call/video/outgoing")({
  validateSearch: outgoingSearchSchema,
  staticData: { hideBottomNav: true },
  beforeLoad: ({ search }) => {
    if (!search.partner_id) {
      throw redirect({ to: "/discover" });
    }
    const { phase } = useCallStore.getState();
    if (phase.type !== "idle" && phase.type !== "outgoingConnecting") {
      throw redirect({ to: "/discover" });
    }
  },
  component: VideoOutgoingPage,
});
